module.exports = __webpack_public_path__ + "static/media/19.fd1a6980.JPG";